import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "external-search-requests" }
const _hoisted_2 = { class: "external-search-requests__header" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { style: {"max-width":"500px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__hr" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterDateRange = _resolveComponent("FilterDateRange")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CardSelect = _resolveComponent("CardSelect")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_ExternalSearchRequestForm = _resolveComponent("ExternalSearchRequestForm")!
  const _component_NModalWindow = _resolveComponent("NModalWindow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.module.items.length) + " " + _toDisplayString(_ctx.$t('external_search.in_total')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.module.filter.current)
            ? (_openBlock(), _createBlock(_component_FilterDateRange, {
                key: 0,
                model: _ctx.module.filter.current,
                hasIntervals: false,
                "clear-button": false
              }, null, 8, ["model"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_UserSelect, {
          modelValue: _ctx.module.filter.current.created_by,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.created_by) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_CardSelect, {
          modelValue: _ctx.module.filter.current.card,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.module.filter.current.card) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_5,
    _createVNode(_component_NTable, {
      columns: _ctx.tableSchema,
      content: _ctx.enrichedItems,
      onAction: _ctx.handleAction,
      onCellClick: _ctx.handleCellClick,
      "active-row": ""
    }, null, 8, ["columns", "content", "onAction", "onCellClick"]),
    _createVNode(_component_InfiniteScroll, {
      onLoadMore: _cache[2] || (_cache[2] = () => _ctx.module.append())
    }),
    (_ctx.currentEnrichedItem)
      ? (_openBlock(), _createBlock(_component_NModalWindow, {
          key: 0,
          layout: true,
          onClose: _ctx.closeRequestForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ExternalSearchRequestForm, {
              item: _ctx.currentEnrichedItem,
              onClose: _ctx.applyRequestForm,
              onDisplayCardImage: _ctx.handleAction
            }, null, 8, ["item", "onClose", "onDisplayCardImage"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}